// E-066
import * as React from "react";
import "./style.css";

interface IProps {
  sentItem?: any;
  title?: any;
  errorAlert?: any;
  success?: any;
}

export class AlertBar extends React.Component<IProps> {
  public render() {
    const short = this.props;

    return (
      <>
        {short?.errorAlert === true ? (
          <div className="alert_red" style={{ backgroundColor: "red" }}>
           ⚠️ <strong> Alert!</strong> {short?.title}
          </div>
        ) : (
          false
        )}
        {short?.success === true ? (
          <div className="alert" style={{ backgroundColor: "green" }}>
            ✅ <strong>Successfully!</strong> OTP has been sent to {short?.sentItem}
          </div>
        ) : (
          false
        )}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/alert-bar/AlertBar.tsx